// user
export const LOGIN = "LOGIN"; // login
export const LOGOUT = "LOGOUT"; // logout
export const SET_ME = "SET_ME"; // set me
export const LOGIN_AS_OTHER_USER = "LOGIN_AS_OTHER_USER"; // login as other user
export const LOGOUT_AS_OTHER_USER = "LOGOUT_AS_OTHER_USER"; // logout as other user